import { waBannerInteraction } from '../../../usage-tracking/events/metadataEditorInteractions';
import { trackEvent } from '../../../usage-tracking/clients/usageTracker';
export const trackWACompose = action => {
  trackEvent(waBannerInteraction({
    action
  }));
};